import { getExperience } from '../helpers/utils'

const initialState = {
  experience: getExperience()
}

function ExperienceReducer(state=initialState, action){
  switch(action.type){
    default:
      return state
  }
}

export default ExperienceReducer


// WEBPACK FOOTER //
// ./app/reducers/ExperienceReducer.js